import React, { PureComponent } from 'react';
import { css } from 'glamor';
import Animated from '../Animated';

import {
  newsletterWrapper,
  newsletterInner,
  columnsLarge,
  header,
  emailInput,
} from './styles';
import {
  textContainer,
  removePaddingBottom,
  hideOnLg,
  hideOnPrint,
} from '../../styles';

class NewsletterSignup extends PureComponent {
  componentWillMount() {
    this.props.loadTheme();
  }
  render() {
    const { theme } = this.props;

    return (
      <div
        {...hideOnPrint}
        {...css({
          transition: 'background 1s ease-out 0.5s',
          backgroundColor: theme.colors[1],
        })}
        {...newsletterWrapper}
      >
        <div {...textContainer} {...newsletterInner} {...removePaddingBottom}>
          <form
            style={{
              border: '1px, solid #ccc',
              padding: '3px',
              textAlign: 'center',
            }}
            action="https://tinyletter.com/lucastswick"
            method="post"
            target="popupwindow"
            onSubmit={() => {
              window.open(
                'https://tinyletter.com/lucastswick',
                'popupwindow',
                'scrollbars=yes,width=800,height=600'
              );
              return true;
            }}
          >
            <Animated as="div">
              <h3 {...header}>
                Curious about <br {...hideOnLg} />Generative Art?
              </h3>
            </Animated>
            <Animated as="p" delay={50}>
              <label htmlFor="tlemail">
                Subscribe to the generative artist mailing list to hear more
                about the medium and the artists who are defining it.
              </label>
            </Animated>
            <Animated as="div" delay={100}>
              <div {...columnsLarge}>
                <input {...emailInput} type="text" name="email" id="tlemail" />
                <input type="hidden" value="1" name="embed" />
                <input type="submit" value="Subscribe" />
              </div>
            </Animated>
          </form>
        </div>
      </div>
    );
  }
}

export default NewsletterSignup;



// WEBPACK FOOTER //
// ./src/components/NewsletterSignup/NewsletterSignup.js